import { render, staticRenderFns } from "./PostingEditModal.vue?vue&type=template&id=51ad5570&scoped=true&"
import script from "./PostingEditModal.vue?vue&type=script&lang=js&"
export * from "./PostingEditModal.vue?vue&type=script&lang=js&"
import style0 from "./PostingEditModal.vue?vue&type=style&index=0&id=51ad5570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ad5570",
  null
  
)

export default component.exports